import React from "react";
import TypeAnimation from "react-type-animation";
import { motion } from "framer-motion";
import "./About.css";
import "../../components/atoms/PrimaryBtn/PrimaryBtn.css";
import "../shared/Shared.css";
import { BottomLine, MySkill, Education } from "../../components";
import { FaDownload } from "react-icons/fa";

const About = () => {
  return (
    <div className="parent pt-16 my-16">
      <div className="">
        <motion.div
          className="mb-10"
          initial={{ y: -200, opacity: 0 }}
          animate={{
            y: 0,
            opacity: 1,
            transition: { duration: 1, type: "spring" },
          }}
        >
          <h3 className="text-neutral text-center">Something About Myself</h3>
          <h1 className="text-4xl font-semibold drop-shadow-md text-center">
            About <span className="text-primary">Me</span>
          </h1>
          <BottomLine />
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-20">
          <motion.div
            initial={{ x: -200, opacity: 0 }}
            animate={{
              x: 0,
              opacity: 1,
              transition: { duration: 1, delay: 1.25 },
            }}
          >
            <img
              src="https://res.cloudinary.com/dlq3ddecx/image/upload/v1708882207/PersonalPictures/bdnio2t7cezhoxmbfavj.png"
              alt="Mujahed ELhaddad"
              className="p-12 w-70 h-70 transform translate-y-[-12%]"
              title="Mujahed ELhaddad"
            />
          </motion.div>
          <motion.div
            className=""
            initial={{ x: 200, opacity: 0 }}
            animate={{
              x: 0,
              opacity: 1,
              transition: { duration: 1, delay: 1.25 },
            }}
          >
            <h1 className="text-4xl font-semibold mb-4 text-center translate-y-[-180%] sm:translate-y-[-0%] sm:text-3xl sm:mb-2 md:text-left">
              Mujahed ELHADDAD
            </h1>
            <div className="my-8">
              <TypeAnimation
                className="text-2xl text-primary font-bold text-center translate-y-[-500%] sm:translate-y-[-0%]  sm:text-2xl sm:mb-2 md:text-left"
                cursor={true}
                sequence={[
                  "A Mern-stack Developer",
                  2500,
                  "A Full-stack Developer",
                  2500,
                  "A Front-end Developer",
                  2500,
                ]}
                wrapper="div"
                repeat={Infinity}
              />
            </div>
            <p className="text-neutral font-medium text-center translate-y-[-100%] sm:translate-y-[-0%] sm:mb-2 md:text-left">
              As a MERN stack developer, I am committed to building high-quality
              web applications and features that meet the needs of my clients.
              With about 5 years experience with coding, I specialize in finding
              solutions to any problem I may face.
            </p>
            <br />
            <p className="text-neutral font-medium text-center translate-y-[-150%] sm:translate-y-[-0%] sm:mb-2 md:text-left">
              At the field of Web development I'm using React.js, Express.js,
              Typescript, MongoDB, Express.js, and Node.js to create scalable
              and robust web applications, among with many different tools.
            </p>
            <br />
            <p className="text-neutral font-medium text-center translate-y-[-115%] sm:translate-y-[-0%] sm:mb-2 md:text-left">
              In short virsion; I'm a Dedicated Front-end developer. Capable to
              solve working problems. Passionate about learning & development to
              reach the target. Eager to tackle more complex problems and
              continue to find ways to maximize user efficiency.
            </p>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-4 mt-4 text-center translate-y-[-50%] sm:translate-y-[-0%] sm:mb-2 md:text-left ">
              <h2 className="font-medium">
                <span className="mr-2 text-primary">Name : </span>Mujahed
                ELHADDAD
              </h2>
              <h2 className="font-medium">
                <a
                  href="https://wa.me/905342200592"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <span className="mr-2 text-primary">Phone : </span>+90 534 220
                  05 92
                </a>
              </h2>

              <h2 className="font-medium">
                <a
                  href="mailto:Mucadad221@gmail.com"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <span
                    className="mr-2 text-primary"
                    href="mailto:Mucadad221@gmail.com"
                  >
                    Email :{" "}
                  </span>
                  Mucadad221@gmail.com
                </a>
              </h2>
              <h2 className="font-medium">
                <span className="mr-2 text-primary">Address : </span>Şanlıurfa,
                Turkey
              </h2>
              <a
                href="https://drive.google.com/file/d/1nwxhvMruVM-n4slHe7xuPrNeNXzizlVH/view"
                target="blank"
              >
                <div className="flex justify-center md:justify-start translate-y-[60%] sm:translate-y-[-0%]">
                  <button className="primary-button">
                    <span>My Resume</span>
                    <span>
                      <FaDownload />
                    </span>
                  </button>
                </div>
              </a>
            </div>
          </motion.div>
        </div>
      </div>
      {/* My Skill */}
      <MySkill />
      {/* Education */}
      <Education />
    </div>
  );
};

export default About;
